//WE.Flow.Html.Contracts.Manifests.Components.DialogManifest

export class DialogManifest {
    isDialog: boolean = false;
    id: string = "";
    name: string = "";
    defaultParameters: any = null;
    viewUrl: string = "";
    namespace: string = "";
    viewModelId: string = "";
    reuseInstance: boolean = false;
    titleClasses: string = "";
    useFormValidation: boolean = false;
    useValidationV3: boolean = false;
    cssUrls: string[] = null;
    tags: string[] = null;
}
